import { ReactNode } from "react";
import { Group } from "../../../types/Group";

interface PlainGroupRendererProps {
  children?: ReactNode;
  group: Group;
}

const PlainGroupRenderer = ({ group, children }: PlainGroupRendererProps) => {
  return (
    <fieldset>
      {group.title && <legend>{group.title}</legend>}
      {children}
    </fieldset>
  );
};

export default PlainGroupRenderer;
